import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { TranslateEditDialogComponent, TranslateEditDialogData } from '@app/modal/translate-edit-dialog/translate-edit-dialog.component';

@Component({
    selector: 'tt-meta-column-item',
    templateUrl: './meta-column-item.component.html',
    styleUrls: ['./meta-column-item.component.css'],
})
export class MetaColumnItemComponent {
    metaColumnKeyno: string;

    metaColumnItemKeyno: string;

    get?: MetaColumnItemGet;

    saving = false;

    deleting = false;

    itemNameFormButtons: FormButton[] = [];

    private translations: { [key: string]: string } = {
        confirm_title: '',
        confirm_message: '',
        confirm_ok_label: '',
        confirm_cancel_label: '',
        error: '',
        ok: '',
    };

    constructor(private state: StateService, private datatask: DataTaskService, private modal: ModalService, private translate: TranslateService, private dialog: MatDialog) {
        this.metaColumnKeyno = state.getStateParams()['metacolumn_keyno'];
        this.metaColumnItemKeyno = state.getStateParams()['metacolumnitem_keyno'];
    }

    public async onSave() {
        this.saving = true;

        try {
            const response = (await this.datatask.Post(3637, this.get))[0];

            if (response.errorcode !== '0') {
                this.modal.show({ type: 'warning', title: this.translations['error'], message: response.errormessage });
            } else {
                this.state.back();
            }
        } finally {
            this.saving = false;
        }
    }

    public async onDelete() {
        if (!!this.get) {
            this.deleting = true;

            try {
                const doDelete = await this.modal.openConfirmDialog({ type: 'danger', message: this.translations['confirm_message'], title: this.translations['confirm_title'] });

                if (doDelete === true) {
                    const response = (await this.datatask.Post(3638, this.get))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({ type: 'warning', title: this.translations['error'], message: response.errormessage });
                    } else {
                        this.state.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async loadProductSettingMcItem() {
        this.get = (await this.datatask.Post(3636, { metacolumn_keyno: this.metaColumnKeyno, metacolumnitem_keyno: this.metaColumnItemKeyno }))[0];

        if (this.get?.show_translation === '1') {
            this.itemNameFormButtons = [{ id: 'translate', type: 'primary', icon: 'far fa-language', tooltip: 'translations', translateTooltip: true, onClick: () => this.openTranslationDialog() }];
        } else {
            this.itemNameFormButtons = [];
        }
    }

    private async translateWords() {
        const response: { [key: string]: string } = await this.translate.translateBatch(Object.keys(this.translations));

        for (let [key, value] of Object.entries(response)) {
            this.translations[key] = value;
        }
    }

    private openTranslationDialog = async () => {
        if (!!this.get) {
            const edits: MetaColumnItemLangEdit[] = await this.datatask.Post(3639, { metacolumnitem_keyno: this.metaColumnItemKeyno });
            const dialogRef = this.dialog.open(TranslateEditDialogComponent, {
                width: '120rem',
                maxWidth: '95vw',
                height: '80vh',
                data: <TranslateEditDialogData<MetaColumnItemLangEdit>>{
                    heading: `${this.get.colname}: (${this.get.metacolumnitem_keyno}) ${this.get.metacolumnitem_name}`,
                    textToTranslate: this.get.metacolumnitem_name,
                    edits: edits,
                    save: async (data) => {
                        await this.datatask.Post(3640, { edits: data.edits });
                        await this.loadProductSettingMcItem();
                        dialogRef.close();
                    },
                    wordNameKey: 'metacolumnitemlang_name',
                    wordIdKey: 'metacolumnitem_keyno',
                },
            });
        }
    };

    ngOnInit(): void {
        this.translateWords();
        this.loadProductSettingMcItem();
    }
}

interface MetaColumnItemGet {
    metacolumn_keyno: string | number;
    colname: string;
    metacolumnitem_keyno: string | number;
    metacolumnitem_name: string;
    sortorder: string | number;
    show_translation: '1' | '0';
}

interface MetaColumnItemLangEdit extends Record<string, string> {
    metacolumnitem_keyno: string;
    metacolumnitemlang_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
    google_language_id: string;
}
